<template>
    <div id='step3'>
        <div class="tips">
            <StepTips title="核對清楚地址資料" text="一旦提交並不能再作出更改，需要重新預約。"/>
        </div>
        <div class="starSlipmentForm">
            <div class="h">
                <div class="startAddress fontH">{{startCName}}</div> 
                <span>取件地址</span>
            </div>
            <div class="contactBox">
                <div class="addContaxt" @click="addContaxt('startContactShow')">
                    <div class="increment" >
                        <span class="el-icon-circle-plus"></span>
                    </div>
                    <span>加入已有聯繫人</span>
                </div>
                <div class="contactList" v-show="startContactShow">
                    <div class="contact" v-for="item in contactList" :key="item.id" @click="fillForm(item,'startFillForm','startContactShow')">
                        <el-row type="flex">
                            <el-col  :span="19">
                                <el-row>
                                    <el-col :span='10'>
                                        <span>{{item.name}}</span>
                                    </el-col>
                                    <el-col :span='10'>
                                        <span>{{item.addressOne}} {{item.addressTwo}} {{item.addressThree}} {{item.address}}</span>
                                    </el-col>
                                    <el-col :span='2'>
                                        <span>{{item.code}}</span>
                                    </el-col>
                                    <el-col :span='10'>
                                        <span>{{item.phoneArea}} </span>
                                        <span> {{item.phone}}</span>
                                    </el-col>
                                    <el-col :span='10'>
                                        <span>{{item.city}}</span>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="3">
                                <optionsButton title="加入"/>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <MailForm :typeId="1"  :contextForm="startFillForm" :callback="startFormCallback" :isTrigger="isTrigger" :initTrigger="initTrigger" :countryId="startCountryId"/>
        </div>
        <div class="endSlipmentForm">
            <div class="h">
                <div class="endAddress fontH">{{endCName}}</div> 
                <span>收件地址</span>
            </div>
            <div class="contactBox">
                <div class="addContaxt" @click="addContaxt('endContactShow')">
                    <div class="increment" >
                        <span class="el-icon-circle-plus"></span>
                    </div>
                    <span>加入已有聯繫人</span>
                </div>
            <div class="contactList" v-show="endContactShow">
                <div class="contact" v-for="item in contactList" :key="item.id" @click="fillForm(item,'endFillForm','endContactShow')">
                    <el-row type="flex">
                        <el-col  :span="19">
                            <el-row>
                                <el-col :span='10'>
                                    <span>{{item.name}}</span>
                                </el-col>
                                <el-col :span='10'>
                                    <span>{{item.addressOne}} {{item.addressTwo}} {{item.addressThree}} {{item.address}}</span>
                                </el-col>
                                <el-col :span='2'>
                                    <span>{{item.code}}</span>
                                </el-col>
                                <el-col :span='10'>
                                    <span>{{item.phoneArea}} </span>
                                    <span> {{item.phone}}</span>
                                </el-col>
                                <el-col :span='10'>
                                    <span>{{item.city}}</span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="3">
                            <optionsButton title="加入"/>
                        </el-col>
                    </el-row>
                </div>
            </div>
            </div>
            <MailForm :typeId="2" :callback="endFormCallback"  :contextForm="endFillForm" :isTrigger="isTrigger" :initTrigger="initTrigger" :countryId="endCountryId"/>
        </div>
        <div class="nextBtn">
            <optionsButton :callback="next" title="下一步"/>
        </div>
    </div>
</template>

<script>
    // 引人组件
import StepTips from '@/components/StepTips.vue'
import optionsButton from '@/components/optionButton'
import {mapState,mapMutations} from 'vuex'
// 表单组件
import MailForm from "@/components/MailForm.vue"
export default {
    name:'Step3',
    components:{
        StepTips,
        optionsButton,
        MailForm
    },
    data(){
        return {
            // 当前每行占的宽度
            colSpan:11,
            // 是否触发表单的校验
            isTrigger:false,
            // 联络人列表
            contactList:"",
            // 寄件人填充表单
            startFillForm: undefined,
            // 收件人填充表单
            endFillForm: undefined,
            // 控制寄件人的联系人列表的展示
            startContactShow:false,
            // 控制收件人的联系人列表的展示
            endContactShow:false,
            // 起点国家ID
            startCountryId: this.$store.state.budgetForm.startId,
            // 终点国家ID
            endCountryId: this.$store.state.budgetForm.endId,
            // 起始国家名
            startCName: this.$store.state.budgetForm.startCName,
            // 结束国家名
            endCName: this.$store.state.budgetForm.endCName
        }
    },
    methods: {
        ...mapMutations(["CHANGESTEP","ADDORDERUSER","INITORDERUSER"]),
        // 获取联系人
        async getContactList(){
            let res = await this.$http.post("app/v2/getAddress")
            console.log(res,"联系人列表")
            if(!res.data.code) return this.$message.error("獲取連絡人失敗")
            this.contactList = res.data.data
        },
        // 监听用户点击添加联系人
        async addContaxt(attr){
            this.getContactList()
            this[attr] = true
        },
        // 起点表单回调
        startFormCallback(form){
            console.log(form,"表单1获取成功")
            this.ADDORDERUSER(form)
            // 保证vuex的寄件人和收件人存在就跳转
            if(this.$store.state.orderVo.orderUsers.length == 2){
            this.$router.push(`step${4}`)
            }
        },
        // 终点表单回调
        endFormCallback(form){
            console.log(form,"表单2获取成功")
            this.ADDORDERUSER(form)
            // 保证vuex的寄件人和收件人存在就跳转
            if(this.$store.state.orderVo.orderUsers.length == 2){
            this.$router.push(`step${4}`)
            }
        },
        // 恢复表单触发回调的依赖属性
        initTrigger(){
            this.isTrigger = false
        },
        // 监听用户点击下一步
        next(){
            // 如果原来的用户列表存在就先删除
            if(this.$store.state.orderVo.orderUsers.length > 0){
                this.INITORDERUSER()
            }

            // 当isTrigger为true会触发表单的验证成功后会自动的添加信息到vuex
            this.isTrigger =  true
        },
        // 监听用户点击加入联系人
        fillForm(form,attr1,attr2){
            // 如果是收件人的填充就把表单类型改为2
            if(attr1=='endFillForm'){
                form.typeId = 2
            }else{
                form.typeId = 1
            }
            this[attr1] = form
            this[attr2] = false
        },
    },
    computed:{
        ...mapState({
            curStep:state=>state.curStep
        })
    },
    // 生命周期创建完成
    created() {
        let orderUsers = this.$store.state.orderVo.orderUsers
        // 如果vuex中有之前表单的数据就获取给页面上的表单
        if(orderUsers.length == 2){
            orderUsers.forEach(item => {
                if(item.typeId == 1){
                    this.startFillForm = item
                }if(item.typeId == 2){
                    this.endFillForm = item
                }
            });
        }
    },
}
</script>

<style lang="less">
#step3{
    .starSlipmentForm,
    .endSlipmentForm{
        .h{
            margin: 50px 0;
            display: flex;
            align-items: center;
            .startAddress,
            .endAddress{
                color: @colorMain;
                font-size: 23px;
                font-weight: 550;
                margin-right: 8px;
            }
        }
        .contactBox{
            display: flex;
            position: relative;
            .addContaxt{
                display: flex;
                align-items: center;
                span{
                    color:@colorMain;
                    font-size:17px;
                    font-weight:550;
                }
                .increment{
                    margin-right:8px;
                    span{
                        color:@colorMain;
                        font-size:30px;
    
                    }
                }
                &:hover{
                    cursor: pointer;
                }
            }
            .contactList{
                .shadowSelect();
                position: absolute;
                z-index: 999;
                left:200px;
                width: 900px;
                background-color:#fff;
                .contact{
                    width: 100%;
                    padding: 20px;
                    &:hover{
                        background-color: #f1efff;
                        cursor: pointer;
                    }
                }
                .contact>.el-row{
                    line-height: 30px;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    button{
                        width: 100%;
                        margin: 0;
                        height: 46px;
                    }
                }
            }
        }
        .el-row{
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
    .nextBtn{
        margin-top: 50px;
        width: 100%;
        button{
            width: 100%;
        }
    }
    .el-form{
        .el-form-item__label{
            font-size: 15px;
            font-weight:550;
            width: 100%;
            text-align: left;
        }
        .el-form-item__content .el-input .el-input__inner{
            border-radius:10px;
            border:1.5px solid;
            border-color:#cbcbcb;
            font-size: 16px;
        }
        .el-select{
            .el-input .el-input__inner{
                border:none;
            }
        }
    }
}
</style>